//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.api

import com.tixforgigs.apax.models.Address
import com.tixforgigs.apax.models.ApiError
import com.tixforgigs.apax.models.BankAccount
import com.tixforgigs.apax.models.CompanyData
import com.tixforgigs.apax.models.RegisterRequest
import com.tixforgigs.apax.models.ResetPasswordRequest
import com.tixforgigs.apax.models.TokenAuthRequest
import com.tixforgigs.apax.models.TokenRedirectUrlResponse
import com.tixforgigs.apax.models.UpdatePasswordRequest
import com.tixforgigs.apax.models.UserData
import com.tixforgigs.apax.models.UserProfile

import com.tixforgigs.apax.infrastructure.*
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.request.forms.formData
import io.ktor.client.engine.HttpClientEngine
import kotlinx.serialization.json.Json
import io.ktor.http.ParametersBuilder
import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

open class CommonAccountApi : ApiClient {

    constructor(
        baseUrl: String = ApiClient.BASE_URL,
        httpClientEngine: HttpClientEngine? = null,
        httpClientConfig: ((HttpClientConfig<*>) -> Unit)? = null,
        jsonSerializer: Json = ApiClient.JSON_DEFAULT
    ) : super(baseUrl = baseUrl, httpClientEngine = httpClientEngine, httpClientConfig = httpClientConfig, jsonBlock = jsonSerializer)

    constructor(
        baseUrl: String,
        httpClient: HttpClient
    ): super(baseUrl = baseUrl, httpClient = httpClient)

    /**
     * Add address. - BETA (version from:4.6 to:latest)
     * ...
     * @param address 
     * @return UserProfile
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountAddressAdd(address: Address): HttpResponse<UserProfile> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = address

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/account/address",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Delete address. - BETA (version from:4.6 to:latest)
     * ...
     * @param addressId the addressId
     * @return UserProfile
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountAddressDelete(addressId: kotlin.Int): HttpResponse<UserProfile> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.DELETE,
            "/account/address/{addressId}".replace("{" + "addressId" + "}", "$addressId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Update address. - BETA (version from:4.6 to:latest)
     * ...
     * @param address 
     * @return UserProfile
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountAddressUpdate(address: Address): HttpResponse<UserProfile> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = address

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.PUT,
            "/account/address",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Add bank details. - BETA (version from:4.6 to:latest)
     * ...
     * @param bankAccount 
     * @return UserProfile
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountBankDetailsAdd(bankAccount: BankAccount): HttpResponse<UserProfile> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = bankAccount

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/account/bank-details",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Delete bank details. - BETA (version from:4.6 to:latest)
     * ...
     * @param bankAccountId the bankAccountId
     * @return UserProfile
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountBankDetailsDelete(bankAccountId: kotlin.Int): HttpResponse<UserProfile> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.DELETE,
            "/account/bank-details/{bankAccountId}".replace("{" + "bankAccountId" + "}", "$bankAccountId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Update bank details. - BETA (version from:4.6 to:latest)
     * ...
     * @param bankAccount 
     * @return UserProfile
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountBankDetailsUpdate(bankAccount: BankAccount): HttpResponse<UserProfile> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = bankAccount

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.PUT,
            "/account/bank-details",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Update company data. - NOT_IMPLEMENTED (version from:4.6 to:latest)
     * ...
     * @param companyData 
     * @return UserProfile
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountCompanyUpdate(companyData: CompanyData): HttpResponse<UserProfile> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = companyData

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.PUT,
            "/account/company",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Account login - BETA (version from:4.6 to:latest)
     * -
     * @param tokenAuthRequest 
     * @return TokenRedirectUrlResponse
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountLogin(tokenAuthRequest: TokenAuthRequest): HttpResponse<TokenRedirectUrlResponse> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = tokenAuthRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/account/login",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * The user can reset their lost password - BETA (version from:4.6 to:latest)
     * -
     * @param resetPasswordRequest 
     * @return void
     */
    open suspend fun accountPasswordReset(resetPasswordRequest: ResetPasswordRequest): HttpResponse<Unit> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = resetPasswordRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/account/password-reset",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * The user can reset their lost password - BETA (version from:4.6 to:latest)
     * -
     * @param updatePasswordRequest 
     * @return void
     */
    open suspend fun accountPasswordUpdate(updatePasswordRequest: UpdatePasswordRequest): HttpResponse<Unit> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = updatePasswordRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/account/password-update",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Get user profile data. - BETA (version from:4.6 to:latest)
     * ...
     * @return UserProfile
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountProfile(): HttpResponse<UserProfile> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/account/profile",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Register user - BETA (version from:4.6 to:latest)
     * -
     * @param registerRequest 
     * @return void
     */
    open suspend fun accountUserAdd(registerRequest: RegisterRequest): HttpResponse<Unit> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = registerRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/account/user",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * Delete user. - NOT_IMPLEMENTED (version from:4.6 to:latest)
     * ...
     * @return void
     */
    open suspend fun accountUserDelete(): HttpResponse<Unit> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.DELETE,
            "/account/user",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Update user data. - BETA (version from:4.6 to:latest)
     * ...
     * @param userData 
     * @return UserProfile
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun accountUserUpdate(userData: UserData): HttpResponse<UserProfile> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = userData

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.PUT,
            "/account/user",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



}
